import * as SidePanelAction from './sidePanel.actionTypes';
import { Dispatch } from 'react';


export const closeSidePanel = (payload?: any) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.CLOSE_SIDE_PANEL,
        payload
    });
}

export const updateCount = (aiId: string, countType: any, count: number, columnId: string, subAiData?: any) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.UPDATE_COUNT,
        aiId,
        countType,
        count,
        columnId,
        subAiData
    });
}

export const boardAddTag = (aiId: string, payload: any,columnId: any) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_ADD_TAG,
        aiId,
        payload,
        columnId
    });
}

export const boardAiparentUpdate = (id: string, parentId: string, columnId: string)  => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_PARENT_UPDATE,
        id,
        parentId,
        columnId
    });
}

export const boardSubToAIparentUpdate = (id: string, oldParentId: string, columnId: string, stateVal: number)  => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_SUB_TO_AI_PARENT_UPDATE,
        id,
        oldParentId,
        columnId,
        stateVal
    });
}

export const boardAiDelete = (aiId: string, columnId: string, parentId?: string, state?: string) =>  (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_DELETE,
        aiId,
        columnId,
        parentId,
        state
    });
}

export const boardChangeAIDesc = (aiId: string, description: string, columnId: string) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_DESC_CHANGE,
        aiId,
        description,
        columnId
    });
}

export const boardAiStartDateChange = ( aiId: string, startDateText: string, startDateTextFormatted: Date | string, start_date: any, columnId: string) => 
    (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
        dispatch({
            type: SidePanelAction.BOARD_AI_START_DATE,
            aiId,
            startDateText,
            startDateTextFormatted,
            start_date,
            columnId
        });
}

export const boardAiEndDateChange = ( aiId: string, dueDateText: string, dueDateTextFormatted: Date | string, due_red: string, due_date: any, columnId: string) => 
    (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
        dispatch({
            type: SidePanelAction.BOARD_AI_END_DATE,
            aiId,
            dueDateText,
            dueDateTextFormatted,
            due_red,
            due_date,
            columnId
        });
}

export const boardAiOwnerChange = (aiId: string, owner: string, first_name: string, last_name: string, ownerImg: string, columnId: string) => 
    (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
        dispatch({
            type: SidePanelAction.BOARD_AI_OWNER_CHANGE,
            aiId,
            owner,
            first_name,
            last_name,
            ownerImg,
            columnId
        });
}

export const boardAiStateChange = (aiId: string, stateId: string, columnId: string) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_STATE,
        aiId,
        stateId,
        columnId
    });
}

export const boardAiRagChange = (aiId: string, ragId: string, columnId: string) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_RAG,
        aiId,
        ragId,
        columnId
    });
}

export const boardAiPriorityChange = (aiId: string, priorityId: string, columnId: string) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_PRIORITY,
        aiId,
        priorityId,
        columnId
    });
}

export const boardAiEffortChange = (aiId: string, effortId: string, columnId: string) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_EFFORT,
        aiId,
        effortId,
        columnId
    });
}

export const boardRemoveTag = (aiId: string, tagId: string, columnId: string) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_REMOVE_TAG,
        aiId,
        tagId,
        columnId
    });
}
export const boardChangeAINotes = (aiId: string, notes: string, columnId: string) => (dispatch: Dispatch<SidePanelAction.SidePanelActionTypes>, getState: any) => {
    dispatch({
        type: SidePanelAction.BOARD_AI_NOTES_CHANGE,
        aiId,
        notes,
        columnId
    });
}


  